<template>
<div ref="pay-card-otp" id="pay-card-otp" class="opt-content-wrapper pay-pane active py-0 pb-0">
    <div class="modal-body pb-1">
        <div class="text-center mt-3">
            <div class="text-center">
                <i class="title-icon warning"></i>
            </div>

            <h5 class="text-center mt-3 mb-5 gray" style="line-height:1.5;">No provider available for this payment option. Kindly use other payment options</h5>

        </div>

        <div class="col-12 px-0 mt-4 text-center">
            <a href="javascript:void(0)" class="change-option" @click.prevent="$emit('changePaymentOption')"> &larr; Choose another method </a>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'ComingSoon',
    props: ['data', 'client_info'],

    computed: {
        item() {
            return this.data.details;
        }
    },
}
</script>
